import { Box } from "@mui/material";

const New = ({ text, style }) => {
  return (
    <Box
      component="span"
      sx={{
        ml: 1,
        px: 0.8,
        py: 0.2,
        fontSize: "9px",
        fontWeight: 700,
        lineHeight: 1.4,
        color: "#fff",
        backgroundColor: "#e53935",
        borderRadius: "4px",
        ...style,

        animation: "pulseNuevo 1.8s ease-in-out infinite",

        "@keyframes pulseNuevo": {
          "0%": {
            transform: "scale(1)",
          },
          "50%": {
            transform: "scale(1.12)",
          },
          "100%": {
            transform: "scale(1)",
          },
        },
      }}
    >
      {text}
    </Box>
  );
};

export default New;
